/**
 * The red strip that says this is the DEV environment (Jeremy, 4 Nov 2026:
 * "YOU ARE IN DEV", both apps, a red banner) -- Fieldpath's
 * components/DevBanner.tsx, the same words and colour.
 *
 * The build decides, never the address: `deploy-app.yml` sets
 * `VITE_DEV_BANNER=yes` only for an app named `*-dev-api`. Production's bundle
 * is built without it, so the comparison below is the constant `false` there
 * and the strip is dropped from the bundle -- the deploy checks that the words
 * are absent from a production bundle.
 */
export function DevBanner() {
  if (import.meta.env.VITE_DEV_BANNER !== "yes") return null;
  return (
    <div className="dev-banner" role="status">
      YOU ARE IN DEV
    </div>
  );
}
